module.exports = __webpack_public_path__ + "img/2.a851cc2b.jpg";